import React from 'react';
import Appbar from '../../../../components/appBar/appBar';
import Footer from '../../../../components/footer/footer';
import GSTMapping from './GSTMapping';
function GSTRepositoryMapping() {
  return (
   
    <div>
      <Appbar />
      <div style={{ marginTop: "80px", marginBottom: "60px" }}>
        <GSTMapping />
      </div>
      <Footer />
    </div>
  
  );
}
export default GSTRepositoryMapping;